const GENERIC_FIGURE_LABEL = /^(?:fig\.?|figure)\s+\d+[a-z]?$/i;
const GENERIC_CHINESE_FIGURE_LABEL = /^图\s*\d+[a-z]?$/i;

export function shouldRenderMarkdownImageCaption(
  alt: string | undefined,
): boolean {
  const text = alt?.trim();
  if (!text) return false;
  return (
    !GENERIC_FIGURE_LABEL.test(text) &&
    !GENERIC_CHINESE_FIGURE_LABEL.test(text)
  );
}
